"use strict";
module.exports = ['$document', '$window', '$parse', '$injector', function ($document, $window, $parse, $injector) {
        return {
            restrict: 'AE',
            link: require('./dragAndScrollCtrl.js')($document, $window, $parse),
        };
    }];



//////////////////
// WEBPACK FOOTER
// ./src/modules/ngDro-uaa/directives/dragAndScroll/dragAndScroll.js
// module id = 366
// module chunks = 0